export default {
    text: 'Football Data',
    path: '/football',
    icon: 'football.svg',
    children: [
        {
            text: 'Competitions',
            path: '/football/competitions',
            children: [],
            permissions: {
                FDATA: 'READ'
            }
        },
        {
            text: 'Seasons',
            path: '/football/seasons',
            children: [],
            permissions: {
                FDATA: 'READ'
            }
        },
        {
            text: 'Comp-seasons',
            path: '/football/compseason',
            children: [],
            permissions: {
                FDATA: 'READ'
            }
        },
        {
            text: 'Stages',
            path: '/football/stage',
            children: [],
            permissions: {
                FMANAGEMENT: 'READ'
            }
        },
        {
            text: 'Gameweeks',
            path: '/football/gameweeks',
            children: [],
            permissions: {
                FDATA: 'READ'
            }
        },
        {
            text: 'Fixtures',
            path: '/football/fixtures',
            children: [],
            permissions: {
                FDATA: 'READ'
            }
        },
        {
            text: 'Clubs',
            path: '/football/clubs',
            children: [],
            permissions: {
                FDATA: 'READ'
            }
        },
        {
            text: 'Teams',
            path: '/football/teams',
            children: [],
            permissions: {
                FDATA: 'READ'
            }
        },
        {
            text: 'Players',
            path: '/football/players',
            children: [],
            permissions: {
                FDATA: 'READ'
            }
        },
        {
            text: 'Team Staff',
            path: '/football/staff',
            children: [],
            permissions: {
                FDATA: 'READ'
            }
        },
        {
            text: 'Match Officials',
            path: '/football/official',
            children: [],
            permissions: {
                FDATA: 'READ'
            }
        },
        {
            text: 'Stadiums',
            path: '/football/stadiums',
            children: [],
            permissions: {
                FDATA: 'READ'
            }
        },
        {
            text: 'Grounds',
            path: '/football/grounds',
            children: [],
            permissions: {
                FDATA: 'READ'
            }
        }
    ],
    permissions: {
        FDATA: 'READ'
    }
};
